/** UI formatters, currency-aware per loaded file. */

export class Formatters {
  readonly money: (n: number) => string;

  constructor(currency: string | null) {
    const fmt = new Intl.NumberFormat('en', { style: 'currency', currency: currency ?? 'USD' });
    this.money = (n) => fmt.format(n);
  }

  date(d: Date): string {
    return d.toLocaleDateString('en', { month: 'short', day: 'numeric', year: 'numeric' });
  }
}
